import { render, staticRenderFns } from "./AboutJacketRatings.vue?vue&type=template&id=4ef0975c"
import script from "./AboutJacketRatings.vue?vue&type=script&lang=js"
export * from "./AboutJacketRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports